export const BREAKPOINTS = {
  TABLET: 960,
  DESKTOP: 1024,
};

export const SELECTORS = {
  PHONE: `@media screen and (max-width: ${BREAKPOINTS.DESKTOP - 1}px)`,
  DESKTOP: `@media screen and (min-width: ${BREAKPOINTS.DESKTOP}px)`,
};
